const HOME_CACHE_KEY =
    "cyk_home_cache_v1";

const HOME_CACHE_MAX_AGE =
    24 * 60 * 60 * 1000;


const getStore = () => {
    try {
        const raw =
            localStorage.getItem(
                HOME_CACHE_KEY
            );

        if (!raw) {
            return {};
        }

        const parsed =
            JSON.parse(raw);

        return (
            parsed &&
            typeof parsed === "object"
        )
            ? parsed
            : {};

    } catch (error) {
        return {};
    }
};


export const readHomeCache = (
    key,
    fallback
) => {
    try {
        const store =
            getStore();

        const item =
            store?.[key];

        if (
            !item ||
            typeof item !== "object"
        ) {
            return fallback;
        }

        const age =
            Date.now() -
            Number(item.time || 0);

        if (
            !Number.isFinite(age) ||
            age >
                HOME_CACHE_MAX_AGE
        ) {
            return fallback;
        }

        return item.value;

    } catch (error) {
        return fallback;
    }
};


export const writeHomeCache = (
    key,
    value
) => {
    try {
        const store =
            getStore();

        store[key] = {
            time: Date.now(),
            value
        };

        localStorage.setItem(
            HOME_CACHE_KEY,
            JSON.stringify(store)
        );

    } catch (error) {
        /*
         * Cache la toi uu UX.
         * Loi cache khong duoc lam hong website.
         */
    }
};
